import React from "react";
import { DashboardContainer } from "./styles";
import { ArrowBack, Rsvp, FactCheck, Image, Settings as SettingsIcon } from "@mui/icons-material";
import {
	Box,
	IconButton,
	Typography,
	Container,
	Grid,
	List,
	MenuItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	colors,
	useTheme,
	useMediaQuery
} from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { INVITATION_PRICING_PLANS_ENUM } from "../../../store/services/invitations/dto/invitations.dto";
import { UpgradeBtn, WhiteCrown } from "../styles";
import { useAppDispatch, useAppSelector } from "../../../store";
import { getFullInvitationsState, setOpenPricingModal } from "../../../store/slices/invitations/invitations.slice";
import { isPast } from "date-fns";
import { trackEvent } from "../../../utils/analytics";
import { trackMetaEvent } from "../../../utils/metaPixel";
import { trackTikTokEvent } from "../../../utils/tiktokPixel";

const Dashboard = () => {
	const navigate = useNavigate();
	const params = useParams();
	const theme = useTheme();
	const isSmallerScreen = useMediaQuery(theme.breakpoints.down("md"));
	const id = params.id;
	const location = useLocation();
	const isOverviewSelected = location.pathname.includes("/overview");
	const isRSVP = location.pathname.includes("/rsvp");
	const isMemories = location.pathname.includes("/memories");
	const isSettings = location.pathname.includes("/settings");
	const dispatch = useAppDispatch();
	const { invitationPayedData, managedInvitation } = useAppSelector(getFullInvitationsState);

	const handleGoBack = () => {
		navigate(`/manageWeddingInvitation/${id}`);
	};

	const handleOpenUpgradeModal = () => {
		trackEvent("upgrade_btn", {
			scope: "Invitations",
			description: "Upgrade Button"
		});
		trackMetaEvent("upgrade_btn", { invitation_id: id }, true);
		trackTikTokEvent("upgrade_btn", { invitation_id: id });
		return dispatch(setOpenPricingModal(true));
	};

	return (
		<DashboardContainer>
			<Container maxWidth={"xl"} sx={{ paddingX: "5px" }}>
				<Box mt={7} height={"94vh"} p={1}>
					<Box display={"flex"} alignItems={"center"} my={2}>
						<Box className={"back-btn"} onClick={handleGoBack}>
							<IconButton>
								<ArrowBack width={20} />
							</IconButton>
							<Typography>Dashboard</Typography>
						</Box>
					</Box>
					<Grid container spacing={4} alignItems={"flex-start"}>
						<Grid size={isSmallerScreen ? 12 : 3} className={"menu-tabs"}>
							<List>
								<MenuItem
									selected={isOverviewSelected}
									onClick={() => navigate(`/manageWeddingInvitation/${id}/dashboard/overview`)}
								>
									<ListItemButton>
										<ListItemIcon style={isSmallerScreen ? { display: "flex", justifyContent: "center" } : {}}>
											<FactCheck />
										</ListItemIcon>
										{!isSmallerScreen && <ListItemText primary="Overview" />}
									</ListItemButton>
								</MenuItem>
								<MenuItem selected={isRSVP} onClick={() => navigate(`/manageWeddingInvitation/${id}/dashboard/rsvp`)}>
									<ListItemButton>
										<ListItemIcon style={isSmallerScreen ? { display: "flex", justifyContent: "center" } : {}}>
											<Rsvp />
										</ListItemIcon>
										{!isSmallerScreen && <ListItemText primary="RSVP" />}
									</ListItemButton>
								</MenuItem>{" "}
								<MenuItem
									selected={isMemories}
									onClick={() => navigate(`/manageWeddingInvitation/${id}/dashboard/memories`)}
								>
									<ListItemButton>
										<ListItemIcon style={isSmallerScreen ? { display: "flex", justifyContent: "center" } : {}}>
											<Image />
										</ListItemIcon>
										{!isSmallerScreen && <ListItemText primary="Memories" />}
									</ListItemButton>
								</MenuItem>{" "}
								<MenuItem
									selected={isSettings}
									onClick={() => navigate(`/manageWeddingInvitation/${id}/dashboard/settings`)}
								>
									<ListItemButton>
										<ListItemIcon style={isSmallerScreen ? { display: "flex", justifyContent: "center" } : {}}>
											<SettingsIcon />
										</ListItemIcon>
										{!isSmallerScreen && <ListItemText primary="Settings" />}
									</ListItemButton>
								</MenuItem>
							</List>
						</Grid>
						<Grid size={isSmallerScreen ? 12 : 9} style={{ backgroundColor: colors.grey[50], padding: 15 }}>
							<Box display={"flex"} justifyContent={isSmallerScreen ? "center" : "flex-end"}>
								{!isPast(new Date(managedInvitation?.wedding_date || "")) &&
									invitationPayedData.type < INVITATION_PRICING_PLANS_ENUM.SIGNATURE && (
										<Box display={"flex"} m={1} justifyContent={"center"} alignItems={"center"} width={"300px"}>
											<UpgradeBtn
												fullWidth
												variant={"contained"}
												startIcon={<WhiteCrown />}
												onClick={handleOpenUpgradeModal}
											>
												Upgrade
											</UpgradeBtn>
										</Box>
									)}
							</Box>
							<Outlet />
						</Grid>
					</Grid>
				</Box>
			</Container>
		</DashboardContainer>
	);
};

export default Dashboard;
